import * as Sentry from "@sentry/browser"
import { FullPageError } from "@/src/routes/sections/fullPageError"
import ServerErrorIcon from "@/src/assets/icons/img_server_error.svg?react"

const DYNAMIC_IMPORT_FAILED_MESSAGE = "Failed to fetch dynamically imported module"
const STORAGE_LAST_IMPORT_ERROR_TIME = "lastImportErrorTime"
const IMPORT_ERROR_RELOAD_THRESHOLD = 3000

export const ErrorElement = (props: { error: Error }) => {
    const error = props.error?.message

    const trackError = (errorMsg: any) => {
        console.error(errorMsg)
        Sentry.captureException(errorMsg)
    }

    if (error?.includes(DYNAMIC_IMPORT_FAILED_MESSAGE)) {
        const lastErrorTime = Number(sessionStorage.getItem(STORAGE_LAST_IMPORT_ERROR_TIME) ?? 0)
        if (Date.now() - lastErrorTime > IMPORT_ERROR_RELOAD_THRESHOLD) {
            sessionStorage.setItem(STORAGE_LAST_IMPORT_ERROR_TIME, Date.now().toString())
            window.location.reload()
        }
        return <></>
    }
    trackError(error)

    return (
        <FullPageError
            headerText="Something went wrong"
            subText1="Please try again"
            buttonText="Go back to Home"
            onButtonClicked={() => {
                window.location.href = "/dashboard"
            }}
            image={<ServerErrorIcon />}
            height={100}
        />
    )
}
